export const iconFontAwesomeMusicVideoSpotify = (
	<i className="fa-solid fa-spotify"></i>
);
